import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { peerReviewTypeList, prestigeTypeList } from '@/module/Publisher';

import { identitySchema } from '@/core/components';

export const publisherSchema = z.object({
  title: z.string().min(3),
  address: z.string().min(3),
  type: identitySchema,
  prestige: z.enum(prestigeTypeList).nullish(),
  peerReview: z.enum(peerReviewTypeList).nullish(),
});

export const defaultPublisherValues: DefaultValues<PublisherSchema> = {
  title: '',
  address: '',
};

export type PublisherSchema = z.infer<typeof publisherSchema>;
